import script from "./ClipRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipRecorder.vue?vue&type=script&setup=true&lang=js"

import "./ClipRecorder.vue?vue&type=style&index=0&id=359e5f5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359e5f5c"]])

export default __exports__